/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `3.5.65-3.7.3` - 3.5.65-3.7.3
 * * `3.5.39-3.7.4.b0` - 3.5.39-3.7.4.b0
 * @export
 */
export const SimulationRunnerEnum = {
  _3_5_65_3_7_3: "3.5.65-3.7.3",
  _3_5_39_3_7_4_B0: "3.5.39-3.7.4.b0",
} as const;
export type SimulationRunnerEnum = (typeof SimulationRunnerEnum)[keyof typeof SimulationRunnerEnum];

export function instanceOfSimulationRunnerEnum(value: any): boolean {
  for (const key in SimulationRunnerEnum) {
    if (Object.prototype.hasOwnProperty.call(SimulationRunnerEnum, key)) {
      if (SimulationRunnerEnum[key as keyof typeof SimulationRunnerEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function SimulationRunnerEnumFromJSON(json: any): SimulationRunnerEnum {
  return SimulationRunnerEnumFromJSONTyped(json, false);
}

export function SimulationRunnerEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SimulationRunnerEnum {
  return json as SimulationRunnerEnum;
}

export function SimulationRunnerEnumToJSON(value?: SimulationRunnerEnum | null): any {
  return value as any;
}

export function SimulationRunnerEnumToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): SimulationRunnerEnum {
  return value as SimulationRunnerEnum;
}
